export default "__VITE_ASSET__BZmSjMht__"